import classNames from "classnames";
import type { CSSProperties } from "styled-components";
import { useTimelineCtx } from "../ctx";
import { TimelineStyleEnum, type ITimelineTrackSegmentProps } from "../types";
import { TimelineMarkerFactory } from "./timeline-marker-factory";

type IProps = ITimelineTrackSegmentProps;

const PATH_COMMON_STYLE: CSSProperties = {
  willChange: "stroke-dashoffset, stroke-dasharray",
  stroke: "var(--timeline-color)",
};

export const TimelineVerticalTrackSegment = ({
  trackSvgData,
  editableMarkerSlot,
  editableTextSlot,
  setSettings,
  itemIdx,
  itemDetails,
}: IProps) => {
  const { svgPathD, svgTraceD, svgStyle, svgPathStyle, svgTraceStyle } =
    trackSvgData;

  const {
    comboSettings: { timelineStyle },
  } = useTimelineCtx();

  const { isContentOnLeft, trackWidth, trackPl, trackPr } = itemDetails;
  const linePx = trackPl + trackPr;

  // Vertical Path: alternate marker alignment so bullets sit on the
  // quarter-wave curve's hard-coded left/right endpoints.
  const isPath = timelineStyle === TimelineStyleEnum.Path;
  const markerEvenLeft = itemIdx % 2 === 0;

  return (
    <div
      className={classNames({
        "tw-relative tw-flex tw-flex-col": true,
        "tw-items-center": !isPath,
        "tw-items-start": isPath && markerEvenLeft,
        "tw-items-end": isPath && !markerEvenLeft,
        "tw-order-1": isContentOnLeft,
      })}
      style={{
        minWidth: trackWidth,
        maxWidth: trackWidth,
        paddingRight: trackPl,
        paddingLeft: trackPr,
      }}
    >
      <TimelineMarkerFactory
        setSettings={setSettings}
        itemIdx={itemIdx}
        editableMarkerSlot={editableMarkerSlot}
        editableTextSlot={editableTextSlot}
      />

      <svg
        className="timeline-line-svg tw-pointer-events-none tw-absolute tw-left-1/2 tw-top-0 tw-max-h-full tw-w-full tw-will-change-[height]"
        style={{
          ...svgStyle.current,
          width: `calc(100% - ${linePx}px)`,
          transform: `translateX(calc(-50% + ${trackPr - trackPl}px / 2))`,
        }}
      >
        <path
          d={svgTraceD.current}
          strokeLinecap="round"
          fill="none"
          className="tw-opacity-40"
          style={{
            ...svgTraceStyle.current,
            ...PATH_COMMON_STYLE,
          }}
        />
        <path
          d={svgPathD.current}
          fill="none"
          strokeLinecap="round"
          style={{
            ...svgPathStyle.current,
            ...PATH_COMMON_STYLE,
          }}
        />
      </svg>
    </div>
  );
};
